export default function ChoiceCard({ option, selected, onSelect, testId }) {
  const Icon = option.icon;
  return (
    <button
      type="button"
      onClick={() => onSelect(option.value)}
      className={`choice-card w-full text-left rounded-2xl border p-5 md:p-6 bg-white border-[#EAEAEA] ${
        selected ? "selected" : ""
      }`}
      data-testid={testId}
      aria-pressed={selected}
    >
      <div className="flex items-start gap-4">
        <div
          className={`shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${
            selected ? "bg-[#0055FF] text-white" : "bg-[#F2F4F8] text-[#111]"
          }`}
        >
          {Icon ? <Icon className="w-5 h-5" /> : null}
        </div>
        <div className="flex-1">
          <div className="font-heading text-lg font-medium">{option.title}</div>
          <p className="mt-2 text-sm text-[#666] leading-relaxed">{option.why}</p>
        </div>
      </div>
    </button>
  );
}
